import { render, staticRenderFns } from "./deleteExamineStaff.vue?vue&type=template&id=714957a4"
import script from "./deleteExamineStaff.vue?vue&type=script&lang=js"
export * from "./deleteExamineStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports